/**
 * SitePick front — 比較ストア（docs/06 §1 / §5 / §10）
 *
 * localStorage キー `sitepick_compare` に「商品 post ID の配列のみ」を保存する。
 * 上限は 3（docs/06）。上限到達時は新規追加を拒否し、最古を勝手に消さない・入れ替えない。
 * 追加順を保持。
 */

import { createIdStore } from "./id-store.js";

const DEFAULT_MAX = 3;

const max =
  window.SITEPICK &&
  window.SITEPICK.limits &&
  Number.isInteger(window.SITEPICK.limits.compareMax)
    ? window.SITEPICK.limits.compareMax
    : DEFAULT_MAX;

export const compareStore = createIdStore({
  key: "sitepick_compare",
  eventName: "sitepick:compare:change",
  max,
});

export const COMPARE_MAX = max;
